import { t } from './translate.js';
export function formatDate(value, options) {
    return new Intl.DateTimeFormat(options.locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: options.timeZone,
    }).format(value);
}
/**
 * Kratke datum bez vodicich nul (cs: „23. 9. 2026"). Krok C2b bod 3: verejna
 * stranka ukazuje datum overeni ceny lidem, ne strojum - ISO `2026-09-23`
 * ani `23. 09. 2026` tam nepatri. Format urcuje `Intl`, ne nas retezec.
 */
export function formatDateShort(value, options) {
    return new Intl.DateTimeFormat(options.locale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: options.timeZone,
    }).format(value);
}
/**
 * Jen HODINA A MINUTA (cs: „14:00"). Krok KAL1: agenda kalendare a program
 * Dneska psaly tento format kazdy po svem (`Intl.DateTimeFormat` inline);
 * dva zapisy teze pravdy se po prvni zmene (12h/24h, vodici nula) rozejdou.
 */
export function formatTime(value, options) {
    return new Intl.DateTimeFormat(options.locale, {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: options.timeZone,
    }).format(value);
}
export function formatDateTime(value, options) {
    return new Intl.DateTimeFormat(options.locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: options.timeZone,
    }).format(value);
}
/** Cisla (pocty, plosne jednotky) - NIKDY castky, ty patri Money.format. */
export function formatNumber(value, options = {
    locale: 'cs-CZ',
}) {
    const { maximumFractionDigits, ...rest } = options;
    return new Intl.NumberFormat(rest.locale, {
        maximumFractionDigits: maximumFractionDigits ?? 3,
    }).format(value);
}
/** Mena se formatuje VZDY pres Money (numeric string), tady jen delegace. */
export function formatMoney(money, locale) {
    return money.format(locale);
}
const UNIT_MAP = {
    meter: 'meter',
    'square-meter': 'square-meter',
    percent: 'percent',
    hour: 'hour',
};
/**
 * Jednotky (plocha m2, delka) dle locale - US ft² konverze je zobrazeni, ne ulozeni.
 * ROZHODNUTI: 'square-meter' chybi v sanctioned unit seznamu nekterych ICU
 * sestav -> pro plochu komponujeme cislo + katalogovy label (cs/en parita),
 * ostatni jednotky jdou nativne pres Intl.
 */
export function formatUnit(value, unit, options) {
    if (unit === 'square-meter') {
        const number = formatNumber(value, options);
        return `${number} ${t('unit.square_meter_long', { locale: options.locale })}`;
    }
    return new Intl.NumberFormat(options.locale, {
        style: 'unit',
        unit: UNIT_MAP[unit],
        unitDisplay: 'long',
    }).format(value);
}
//# sourceMappingURL=intl.js.map